import { ArrowRight, Lock } from "lucide-react";
import SmartImage from "@/components/SmartImage";
import { Link } from "react-router-dom";

interface ServiceCardProps {
  title: string;
  description: string;
  image: string;
  href: string;
  disabled?: boolean;
}

const ServiceCard = ({ title, description, image, href, disabled = false }: ServiceCardProps) => {
  const isExternal = href.startsWith("#") || href.startsWith("http");

  const CardContent = () => (
    <>
      <div className="aspect-[16/10] overflow-hidden">
        <SmartImage
          src={image}
          alt={`${title} services by Hill Brothers Painting`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      
      <div className="p-6">
        <h3 className="font-heading font-bold text-xl text-foreground mb-2 group-hover:text-primary transition-colors">
          {title}
        </h3>
        <p className="text-muted-foreground mb-4">{description}</p>
        
        {!disabled && (
          <span className="inline-flex items-center gap-2 text-primary font-semibold text-sm group-hover:gap-3 transition-all">
            View Gallery
            <ArrowRight className="w-4 h-4" aria-hidden="true" />
          </span>
        )}
      </div>

      {disabled && (
        <div className="absolute inset-0 bg-foreground/70 rounded-xl flex flex-col items-center justify-center text-card">
          <Lock className="w-10 h-10 mb-3" aria-hidden="true" />
          <span className="font-heading font-bold text-xl">Coming Soon</span>
        </div>
      )}
    </>
  );

  if (disabled) {
    return (
      <div className="service-card service-card-disabled group relative" aria-disabled="true">
        <CardContent />
      </div>
    );
  }

  // Use React Router Link for internal routes
  if (!isExternal) {
    return (
      <Link 
        to={href} 
        className="service-card group block focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded-xl"
      >
        <CardContent />
      </Link>
    );
  }

  return (
    <a 
      href={href} 
      className="service-card group block focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded-xl"
    >
      <CardContent />
    </a>
  );
};

export default ServiceCard;
